module.exports = __webpack_public_path__ + "static/img/call_flow_type_no_working.35be95fb.svg";